import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ButtonGroup, Button, Row, Col } from 'react-bootstrap';
import get from 'lodash/get';
import { routerActions } from 'connected-react-router';
import { submission as utilSubmission } from '../../utils';
import { ActionBar, ContactUs, CoverageBlock, Upsell } from '../../submissions/components';
import { excessQuoteSelection, limitChange, adjustedCommissionChange, changePricingValue } from '../../submissions/actions';
import * as ratingsActions from '../../ratings/actions';
import * as submissionActions from '../../submissions/actions';
import PriceInputSelector from '../../submissions/components/PriceInputSelector';
import featureFlags from '../../utils/featureFlags'
import isUnderwriter from '../../utils/is-underwriter'
import { QUOTE_STATUS_BOUND_MANUAL } from '../../submissions/components/ChangeQuoteStatusModal';
import config from '../../../config';
import ToastMessage, { toastify } from '../../components/shared/Toasts';

const toastArgopiErrorMessage = (message) => {
    return (
        <ToastMessage icon="exclamation">
            Problem with opening ArgoPI<br />
            {message}
        </ToastMessage>
    );
}

class PendingStatus extends Component {
    constructor(props) {
        super(props);

        const type = get(props.submission, 'type', 'default');
        const additionalCoverage = utilSubmission.getAdditionalCoverageSelection(
            get(props.submission, 'coverages.gl.additional', {}), type, props.submission
        );
        const optionalCoverage = utilSubmission.getOptionalCoverageSelection(
            get(props.submission, 'coverages.gl.optional', {}), type
        );
        const setInitialRate = isUnderwriter(this.props.user) ? props.ratings : null;

        this.state = {
            coverage: get(props.submission, 'coverages.gl.base', 'standard'),
            additionalCoverage,
            optionalCoverage,
            included: get(props.submission, 'included'),
            excessLimitAmount: get(props.submission, 'excessLimitAmount'),
            limitsRequested: get(props.submission, 'limitsRequested'),
            adjustedCommission: get(props.submission, 'adjustedCommission', null),
            pricingValues: utilSubmission.setInitialPricingValues(
                setInitialRate,
                props.submission,
                props.submission.coverages.gl.base,
                isUnderwriter(props.user)),
            userActions: [], // Used for Manually Set Premium for Limit and Lender covg changes.
            schedFactorForReapply: null // used to re-apply factor after rating has been called for commission adjustment.
        };

        this.handleUpsell = this.handleUpsell.bind(this);
        this.handleRequote = this.handleRequote.bind(this);
        this.handleCoverageChange = this.handleCoverageChange.bind(this);
        this.handleAdditionalCoverageChange = this.handleAdditionalCoverageChange.bind(this);
        this.handleIncludedCoverageChange = this.handleIncludedCoverageChange.bind(this);
        this.handleOptionalCoverageChange = this.handleOptionalCoverageChange.bind(this);
        this.handleAdditionalInsuredChange = this.handleAdditionalInsuredChange.bind(this);
        this.updateAdditionalInsuredList = this.updateAdditionalInsuredList.bind(this);
        this.handleExcessCheck = this.handleExcessCheck.bind(this);
        this.limitChange = this.limitChange.bind(this);
        this.handleNetQuote = this.handleNetQuote.bind(this);
        this.handlePriceInputSelector = this.handlePriceInputSelector.bind(this);
        this.onBlurPriceTextboxHandler = this.onBlurPriceTextboxHandler.bind(this);
        this.handleUpdateRatings = this.handleUpdateRatings.bind(this);
        this.updateTotalPremium = this.updateTotalPremium.bind(this);
        this.onCreditNotes = this.onCreditNotes.bind(this);
        this.onGCLimitNotes = this.onGCLimitNotes.bind(this);
        this.handleReturn = this.handleReturn.bind(this);
        this.handleQuoteExcessOnly = this.handleQuoteExcessOnly.bind(this);
        this.handleLoadArgopi = this.handleLoadArgopi.bind(this);
    }

    componentDidMount() {
        if (this.props.submission.type === 'oi'
        && this.state.coverage !== 'deductibleWarranty'
        && (!Object.hasOwn(this.state.pricingValues.baseCoverageOption, 'deductibleWarranty')
            || Number.isNaN(this.state.pricingValues.baseCoverageOption['deductibleWarranty']))
        && this.props.submission.otherSubcontractorsPaid === 'false'
        && (!this.props.manuallySetPricing
            || this.props.manuallySetPricing && isUnderwriter(this.props.user))) {
            /**
             * deductibleWarranty Base Coverage is missing or NaN, so set to 0 which is needed by
             * CoverageSelector component.
             */
            this.setState({
                pricingValues: {
                    ...this.state.pricingValues,
                    baseCoverageOption: {
                        ...this.state.pricingValues.baseCoverageOption,
                        deductibleWarranty: 0
                    }
                }
            }, () => this.handleUpdateRatings(this.props.manuallySetPricing));
        } else if (this.props.manuallySetPricing && isUnderwriter(this.props.user)
            && !Object.hasOwn(this.state.pricingValues, 'systemLimits')) {
            this.handleUpdateRatings(this.props.manuallySetPricing);
        } else if (this.props.manuallySetPricing && isUnderwriter(this.props.user)
            && this.state.coverage === 'deductibleWarranty' 
            && !Object.hasOwn(this.state.pricingValues, 'surcharge')) {
            this.handleUpdateRatings(this.props.manuallySetPricing);
        } else if (this.props.manuallySetPricing &&
            !this.state.pricingValues.hasOwnProperty('systemBasePremium') &&
            isUnderwriter(this.props.user)) {
            this.handleUpdateRatings(false, this.props.fetchRatingsNoPricing);   
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.manuallySetPricing === true && prevProps.manuallySetPricing === false) {
            this.handleUpdateRatings();
        } else if (this.props.manuallySetPricing &&
            prevProps.ratings.isBusy === true &&
            this.props.ratings.isBusy === false &&
            this.props.ratings.updatePricing === true) {

            if (isUnderwriter(this.props.user)) {
                const pricingValues = utilSubmission.updatePricingValuesFromRatings(
                    this.props.ratings,
                    prevProps.ratings,
                    this.props.submission,
                    this.state.pricingValues,
                    get(this.props.submission, 'coverages.gl.base', ''),
                    this.state.userActions,
                    isUnderwriter(this.props.user),
                    this.state.additionalCoverage,
                    this.state.excessLimitAmount
                );
                if (pricingValues != null && this.state.schedFactorForReapply != null) {
                    this.setState({
                        schedFactorForReapply: null,
                        userActions: [],
                        pricingValues: {
                            ...pricingValues,
                            basePremium: pricingValues.basePremium * this.state.schedFactorForReapply
                        }
                    }, () => {
                        this.handleUpdateRatings(this.props.manuallySetPricing);
                    });
                } else if (pricingValues != null) {
                    this.setState({
                        pricingValues: pricingValues,
                        userActions: []
                    }, () => {
                        this.updateTotalPremium();
                    });
                    const { type } = this.props.submission;
                    if (this.props.submission.ratings[type].basePremium !== pricingValues.basePremium) {
                        this.props.onBlurPriceTextboxHandler({ basePremium: pricingValues.basePremium })
                    }
                } else {
                    this.setState({
                        userActions: []
                    }, () => {
                        this.updateTotalPremium();
                    });
                }
            } else {
                this.setState({ pricingValues: utilSubmission.resetPricingValues(this.state.pricingValues) })
            }
        }
        if (this.props.app.argopiResp && !this.props.app.argopiFailed) {
            const { ioReqSuccess, couchBaseId } = this.props.app.argopiResp;
            if (ioReqSuccess === "true") {
                const argoPIWindow = window.open(`${config.argopiURL}/ArgoPI/app?id=${couchBaseId}`, '_blank');
                this.setState({
                    ...this.state,
                    argoPIWindow
                })
            } else {
                toastify.error(toastArgopiErrorMessage('Please try again!'));
            } 
            this.props.loadArgopiReset();          
        } else if (this.props.app.argopiLoaded === false) {
            toastify.error(toastArgopiErrorMessage('Please contact IT support!'));
            this.props.loadArgopiReset();
        }
    }

    handleUpsell() {
        this.props.handleUpsell();
    }

    handleRequote() {
        if (this.state.argoPIWindow) {
            this.state.argoPIWindow.close();
            const newState = this.state;
            delete newState.argoPIWindow;
            this.setState({
                state: newState
            }
            )
        }
        this.props.onBlurPriceTextboxHandler(this.state.pricingValues);
        this.props.handleRequote(this.state.pricingValues);
    }

    handleLoadArgopi() {
        if (this.state.argoPIWindow) {
            this.state.argoPIWindow.close();
            const newState = this.state;
            delete newState.argoPIWindow;
            this.setState({
                state: newState
            }
            )
        }
        this.props.onBlurPriceTextboxHandler(this.state.pricingValues);
        this.props.handleLoadArgopi(this.state.pricingValues);
    }

    handleQuoteExcessOnly() {
        if (this.state.argoPIWindow) {
            this.state.argoPIWindow.close();
            const newState = this.state;
            delete newState.argoPIWindow;
            this.setState({
                state: newState
            }
            )
        }
        this.props.onBlurPriceTextboxHandler(this.state.pricingValues);
        this.props.handleRequote(this.state.pricingValues, true);
    }

    handleExcessCheck(e) {
        let checkedExcess;

        if (e.target.type === 'checkbox' && e.target.checked) {
            checkedExcess = '5000000';
        } else if (e.target.type === 'checkbox' && !e.target.checked) {
            checkedExcess = 'noExcess';
        } else {
            checkedExcess = e.target.value;
        }

        let userActionsCopy = [...this.state.userActions];
        if (this.props.manuallySetPricing) {
            userActionsCopy.push(utilSubmission.userActionsConstants.LIMITS_CHANGED);
        }

        this.setState({
            excessLimitAmount: checkedExcess,
            userActions: userActionsCopy
        }, () => this.handleUpdateRatings(this.props.manuallySetPricing));

        this.props.excessQuoteSelection(checkedExcess);
    }


    limitChange(e) {
        let userActionsCopy = [...this.state.userActions];
        if (this.props.manuallySetPricing) {
            userActionsCopy.push(utilSubmission.userActionsConstants.LIMITS_CHANGED);
        }
        this.setState({
            limitsRequested: e.target.value,
            userActions: userActionsCopy
        }, () => this.handleUpdateRatings());
        this.props.limitChange(e.target.value);
    }

    handleNetQuote(adjustedCommission) {
        if (adjustedCommission === this.state.adjustedCommission) return;
        const { commission } = this.props.submission;
        const totalAdjustedCommission = adjustedCommission - commission;
        let schedMod = null;
        let basePrem = this.state.pricingValues.basePremium;
        if (this.manualPremiumExistsAndNotEqualToBase()) {
                schedMod = this.state.pricingValues.basePremium / this.state.pricingValues.systemBasePremium;
                basePrem = this.state.pricingValues.systemBasePremium;
        }

        let userActionsCopy = [...this.state.userActions];
        if (this.props.manuallySetPricing) {
            userActionsCopy.push(utilSubmission.userActionsConstants.COMMISSION_CHANGED);
        }
        this.props.adjustedCommissionChange(adjustedCommission, '' + totalAdjustedCommission);
        this.setState({
            adjustedCommission,
            schedFactorForReapply: schedMod,
            userActions: userActionsCopy,
            pricingValues: {
                ...this.state.pricingValues,
                basePremium: basePrem
            }
        }, () => this.handleUpdateRatings(this.props.manuallySetPricing));
    }

    handleReturn() {
        this.props.returntoSubmission();
    }

    countRelatedSubmissions(submission) {
        const relatedSubmissions = get(submission, 'relatedEntities.submissions');
        return relatedSubmissions ? relatedSubmissions.length : 0;
    }

    handleIncludedCoverageChange(values) {
        this.setState({ included: values }, () => {
            this.updateTotalPremium()
        });
    }

    enableUpdateExcess(data) {
        const { excessLimitAmount = null, revisionNumber = 0, manualQuoteStatus = ''} = data;
        if (manualQuoteStatus === QUOTE_STATUS_BOUND_MANUAL &&
            typeof excessLimitAmount === 'string' &&
            excessLimitAmount.length > 0 &&
            excessLimitAmount.toLowerCase() !== 'noexcess'
        ) {
            return 1;
        }
        return 0;
    }

    handleAdditionalCoverageChange(evt, values) {
        const additionalCoverage = utilSubmission.createAdditionalCoverageSelection(values);

        let userActionsCopy = [...this.state.userActions];
        if (this.props.manuallySetPricing) {
            if (evt.target.value === 'bankPremium' ||
                (evt.target.value === 'on' &&
                    additionalCoverage.hasOwnProperty('bankPremium') &&
                    !this.state.additionalCoverage.hasOwnProperty('bankPremium'))) {
                userActionsCopy.push(utilSubmission.userActionsConstants.ADDL_COVG_LENDER_CHANGED);
            }
        }

        this.setState({
            additionalCoverage,
            userActions: userActionsCopy
        }, () => {
            this.handleUpdateRatings(this.props.manuallySetPricing)
        });

        if (this.props.handleAdditionalCoverageChange) {
            this.props.handleAdditionalCoverageChange(evt, additionalCoverage);
        }
    }

    handleOptionalCoverageChange(evt, values) {
        const optionalCoverage = utilSubmission.createOptionalCoverageSelection(values);

        this.setState({
            optionalCoverage
        }, () => this.handleUpdateRatings(this.props.manuallySetPricing));

        if (this.props.handleOptionalCoverageChange) {
            this.props.handleOptionalCoverageChange(evt, optionalCoverage);
        }
    }

    handleAdditionalInsuredChange(evt, formValues) {

        if (this.props.handleAdditionalInsuredChange) {
            this.props.handleAdditionalInsuredChange(evt, formValues);
            this.setState({
                pricingValues: {
                    ...this.state.pricingValues,
                    additionalInsureds: this.props.submission.ratings.oi.additionalInsureds
                }
            }, () => {
                this.updateTotalPremium()
            })
        }
    }

    updateAdditionalInsuredList(event) {
        if (this.props.updateAdditionalInsuredList) {
            this.props.updateAdditionalInsuredList(event);
            this.setState({
                pricingValues: {
                    ...this.state.pricingValues,
                    additionalInsureds: this.props.submission.ratings.oi.additionalInsureds
                }
            }, () => {
                this.updateTotalPremium()
            })
        }
    }

    handleCoverageChange(evt, value) {
        let schedMod = null;
        if (this.manualPremiumExistsAndNotEqualToBase()) {
                schedMod = this.state.pricingValues.basePremium / this.state.pricingValues.systemBasePremium
        }
        this.setState({
            coverage: value,
            schedFactorForReapply: schedMod,
            pricingValues: {
                ...utilSubmission.setBaseCoverageInPricingValues(this.state.pricingValues, value),
                systemBasePremium: null
            }
        }, () => {
            this.handleUpdateRatings(this.props.manuallySetPricing)
            this.props.changePricingValue({ baseCoverageOption: this.state.pricingValues.baseCoverageOption })
        });
        this.props.handleCoverageChange(evt, value);
    }

    handleUpdateRatings(includeManualPrems = false, actionOverride = null) {
        let props = utilSubmission.getRatingProperties(this.props.submission);
        if (props.hasOwnProperty('excessLimitAmount')) {
            props.excessLimitAmount = this.state.excessLimitAmount; // local state should always have the latest value.
        }
        let optionslCoverage = this.props.submission.coverages.gl;
        let boolPCOpsExcluded = !!optionslCoverage.optional && optionslCoverage.optional.isPCOpsExcluded ? optionslCoverage.optional.isPCOpsExcluded.selected : false;
        props.isPCOpsExcluded = boolPCOpsExcluded;
        if (props.isPCOpsExcluded == true && this.state.additionalCoverage.extendedCompletedOps) {
            delete this.state.additionalCoverage.extendedCompletedOps;
        }
        if (!props.dateOfCreation) {
            props.dateOfCreation = this.props.submission.createdAt;
        }

        this.props.submission.isBankSelected = this.state.additionalCoverage.bankPremium && !!this.state.additionalCoverage.bankPremium.selected ?
            this.state.additionalCoverage.bankPremium.selected : false;
        let formKey = 0;
        this.state.additionalCoverage.additionalInsureds &&
            this.props.submission.additionalInsuredArray && this.props.submission.additionalInsuredArray.map((ins) => {
                let isLender = false;
                let temp = null;
                Object.keys(ins).map(ind => {
                    if ((ind.endsWith('InsuredRelationship') || ind.endsWith('InsuredRole')) && ins[ind] === 'Lender/Mortgagee') {
                        isLender = true;
                    }
                    if (ind.endsWith('InsuredForms') && !!(ins[ind])) {
                        temp = ins[ind].split(',').filter(key => key !== null && key !== '');
                    }

                    if (!!temp && isLender) {
                        formKey = parseInt(formKey) + parseInt(temp.length);
                        temp = null;
                        isLender = false;
                    }
                    return formKey;
                });
                return formKey;
            });
        Object.assign(props, {
            additionalCoverage: Object.keys(this.state.additionalCoverage).join(','),
            optionalCoverage: Object.keys(this.state.optionalCoverage).join(','),
            baseCoverage: this.state.coverage,
            isBankSelected: this.props.submission.isBankSelected,
            numberOfBankAIForms: formKey,
        });
        props.hnoaRequired = props.additionalCoverage.includes('hnoaPremium');
        if (includeManualPrems && isUnderwriter(this.props.user)) {
            if (!this.state.userActions.includes(utilSubmission.userActionsConstants.COMMISSION_CHANGED) &&
                ((this.state.pricingValues.hasOwnProperty('systemBasePremium') &&
                this.state.pricingValues.systemBasePremium !== null &&
                this.state.pricingValues.basePremium != this.state.pricingValues.systemBasePremium) ||
                !this.state.pricingValues.hasOwnProperty('systemBasePremium'))) {
            props.manualPremium = this.state.pricingValues.basePremium;
            }
            if (this.state.pricingValues.additionalInsureds != null) {
                props.aiManualPremium = this.state.pricingValues.additionalInsureds;
            }
        }
        if (actionOverride == null) {
            this.props.fetchRatings(props);
        } else {
            actionOverride(props);
        }
        if (!isUnderwriter(this.props.user)) {
            this.setState({ isCoverageUpdatedByBroker: true })
        }
    }

    onCreditNotes(val) {
        this.setState({
            onCreditNotes: val
        })
        this.props.onCreditNotes(val)
    }

    onGCLimitNotes(val) {
        this.setState({
            onGCLimitNotes: val
        })
        this.props.onGCLimitNotes(val)
    }

    manualPremiumExistsAndNotEqualToBase() {
        if (this.props.manuallySetPricing &&
            this.state.pricingValues.hasOwnProperty('systemBasePremium') &&
            this.state.pricingValues.systemBasePremium != null &&
            this.state.pricingValues.basePremium != this.state.pricingValues.systemBasePremium) {
            return true;
        }
        return false;
    }

    updateTotalPremium() {
        const addCoverages = this.state.additionalCoverage
        const includedCoverages = this.state.included
        const addCoverageList = Object.keys(addCoverages)
        const pricingValues = this.state.pricingValues;
        const premiumValues = Object.keys(pricingValues).filter(key =>
            !(includedCoverages && includedCoverages.some(includecov => key.includes(includecov))) &&
            (
                key.includes("basePremium") ||
                addCoverageList.some(addcov => key.includes(addcov)
                )
            )).reduce((obj, key) => { obj[key] = pricingValues[key]; return obj }, {})
        const surcharge = pricingValues.surcharge !== undefined ? pricingValues.surcharge : 0
        const totalPremium = Object.values(premiumValues).reduce((t, val) => Number(t) + val)
        const policyPremium = totalPremium
        pricingValues.policyPremium = policyPremium
        pricingValues.totalPremium = totalPremium + surcharge
        this.setState({ pricingValues: Object.assign({}, pricingValues) })
        this.props.onBlurPriceTextboxHandler({ "totalPremium": totalPremium })
        this.props.onBlurPriceTextboxHandler({ "totalPrimaryPremium": totalPremium })
        this.props.onBlurPriceTextboxHandler({ "policyPremium": policyPremium })
        //update excess premium
        const excessPremiumCoverages = ["excessPremium", "excessTerrorPremium"]
        const excessPremiumValues = Object.keys(pricingValues)
            .filter(key => excessPremiumCoverages.includes(key))
            .reduce((obj, key) => { obj[key] = pricingValues[key]; return obj }, {})
        const excessPremium = Object.values(excessPremiumValues)
            .reduce((t, val) => Number(t) + val, 0)
        this.setState({ pricingValues: Object.assign({}, pricingValues, { "totalExcessPremium": excessPremium }) })
        this.props.onBlurPriceTextboxHandler({ "totalExcessPremium": excessPremium })
    }

    fullProductName(productType) {
        const mapping = {
            oi: "Owner's Interest",
            ocp: "Owner's Contractors Protective"
        };
        return mapping[productType];
    }

    handlePriceInputSelector(event, selectedValue) {
        if (selectedValue === 'manuallySetPricing') {
            this.setState({
                pricingValues: {
                    ...this.state.pricingValues,
                    systemBasePremium: null
                }
            }, () => {
                // handleUpdateRatings will be called from componentDidUpdate
                // after manualSetPricing prop changes.
                this.props.handlePriceInputSelector(event, selectedValue);
            });
        } else {
            this.props.handlePriceInputSelector(event, selectedValue)
            this.handleUpdateRatings(selectedValue === 'manuallySetPricing')
        }
    }

    onBlurPriceTextboxHandler(priceValue) {
        if (priceValue.hasOwnProperty('basePremium') && this.props.manuallySetPricing) {
            if (this.state.pricingValues.basePremium !== priceValue.basePremium) {
                this.setState({
                    pricingValues: Object.assign({}, this.state.pricingValues, priceValue)
                }, () => {
                    this.handleUpdateRatings(this.props.manuallySetPricing)
                })
            }
        } else {
            this.setState({ 
                pricingValues: {
                    ...this.state.pricingValues,
                    ...priceValue 
                }
            }, this.updateTotalPremium);
        }
        this.props.onBlurPriceTextboxHandler(priceValue)
    }

    render() {
        const { submission, ratings, manuallySetPricing, updatePricingOptions, onCreditNotes, onGCLimitNotes } = this.props;
        const [firstRating] = ratings.items;
        const { isBusy: isModified } = ratings;

        const fullProductName = this.fullProductName(submission.type);

        const activators = [
            {
                label: `Update ${submission.type === 'oi' ? 'OCP' : 'OI'} Submission`,
                style: 'primary',
                data: submission,
                condition: this.countRelatedSubmissions,
                handler: this.handleUpsell
            },
            {
                label: 'Return to Submissions',
                style: 'link',
                handler: this.handleReturn
            }
        ];

        if (isUnderwriter(this.props.user)) {
            if (this.props.manuallySetPricing === true) {
                activators.unshift({
                    label: 'View Forms',
                    handler: this.handleLoadArgopi,
                    isLoading: this.props.app.argopiLoaded,
                    additionalStyle: 'btn-view-forms',
                    alwaysActive: true,
                    dirtValues: [
                        this.state.limitsRequested,
                        this.state.adjustedCommission,
                        Object.keys(this.state.additionalCoverage),
                        Object.keys(this.state.optionalCoverage),
                        manuallySetPricing,
                        this.state.pricingValues,
                        this.state.onCreditNotes
                        // true,
                    ]
                });
            }
        }

        if (submission.type === 'oi') {
            if (isUnderwriter(this.props.user)) {
                activators.unshift({
                    label: 'Update Excess',
                    handler: this.handleQuoteExcessOnly,
                    disableManually: this.props.app.argopiLoaded,
                    data: {
                        revisionNumber: submission.revisionNumber,
                        excessLimitAmount: this.state.excessLimitAmount,
                        manualQuoteStatus: submission.manualQuoteStatus,
                    },
                    condition: this.enableUpdateExcess,
                    dirtValues: [
                        this.state.coverage,
                        this.state.excessLimitAmount,
                        this.state.additionalCoverage,
                        this.state.optionalCoverage,
                        this.state.adjustedCommission,
                        manuallySetPricing,
                        this.state.pricingValues,
                        this.state.onCreditNotes,
                        this.state.onGCLimitNotes
                    ]
                });
            }
            activators.unshift({
                label: 'Submit',
                handler: this.handleRequote,
                disableManually: this.props.app.argopiLoaded,
                dirtValues: [
                    this.state.coverage,
                    this.state.excessLimitAmount,
                    this.state.additionalCoverage,
                    this.state.optionalCoverage,
                    this.state.adjustedCommission,
                    manuallySetPricing,
                    this.state.pricingValues,
                    this.state.onCreditNotes,
                    this.state.onGCLimitNotes
                ]
            });
        } else if (submission.type === 'ocp') {
            activators.unshift({
                label: 'Submit',
                handler: this.handleRequote,
                disableManually: this.props.app.argopiLoaded,
                dirtValues: [
                    this.state.limitsRequested,
                    this.state.adjustedCommission,
                    this.state.additionalCoverage,
                    this.state.optionalCoverage,
                    manuallySetPricing,
                    this.state.pricingValues,
                    this.state.onCreditNotes,
                    this.state.onGCLimitNotes
                ]
            });
        }
        return (
            <div>
                <header>
                    <div className="h2 mt mb">
                        <strong>Your {fullProductName} submission is being reviewed</strong>
                    </div>
                    <legend />
                    <div className="submission-reasons">
                        <p>
                            We received your submission, but couldn&apos;t provide an instant
                            pricing summary for the following reason(s):
                    </p>
                        <ul>
                            <li>
                                Clearance is pending: submission could not be automatically cleared
                        </li>
                        </ul>
                        <p>
                            <strong>An underwriter will contact you shortly</strong> to help
                            finalize your pricing summary.
                    </p>
                    </div>
                </header>

                {isUnderwriter(this.props.user) && <PriceInputSelector onChange={this.handlePriceInputSelector} defaultValue={manuallySetPricing} />}

                <CoverageBlock
                    isModified={isModified}
                    rating={isUnderwriter(this.props.user) ? firstRating : undefined}
                    coverage={this.state.coverage}
                    additionalCoverage={this.state.additionalCoverage}
                    optionalCoverage={this.state.optionalCoverage}
                    submission={submission}
                    handleAdditionalCoverageChange={this.handleAdditionalCoverageChange}
                    handleIncludedCoverageChange={this.handleIncludedCoverageChange}
                    handleOptionalCoverageChange={this.handleOptionalCoverageChange}
                    handleAdditionalInsuredChange={this.handleAdditionalInsuredChange}
                    updateAdditionalInsuredList={this.updateAdditionalInsuredList}
                    handleCoverageChange={this.handleCoverageChange}
                    handleExcessCheck={this.handleExcessCheck}
                    limitChange={this.limitChange}
                    handleNetQuote={this.handleNetQuote}
                    netQuoteValue={this.state.netQuoteValue}
                    adjustedCommission={this.state.adjustedCommission}
                    manuallySetPricing={manuallySetPricing}
                    onBlurHandler={this.onBlurPriceTextboxHandler}
                    pricingValues={this.state.pricingValues}
                    updatePricingOptions={updatePricingOptions}
                    isUnderwriter={isUnderwriter(this.props.user)}
                    changePricingValue={this.props.changePricingValue}
                    onCreditNotes={this.onCreditNotes}
                    onGCLimitNotes={this.onGCLimitNotes}
                    excessLimitAmount={this.state.excessLimitAmount}
                />

                <ActionBar activators={activators} isActiveBrokerage={this.props.isActiveBrokerage} submission={submission} manuallySetPricing={this.props.manuallySetPricing}/>
                {submission.transactionStatus === 'IP' && this.props.manuallySetPricing ?
                    <p style ={{fontWeight: 'bolder', color: '#c7522a', marginTop: '10px', fontSize: '15px'}}>
                    {isUnderwriter(this.props.user) ? `The quote forms are previewed/updated in ArgoPI. Please submit to generate the updated quote document.`
                        : `Please note this submission has been locked for editing by your underwriter. Please reach out to them with any changes you may need to make on this account.`}
                    </p> : null}
                <Upsell submission={submission} onSubmit={this.handleUpsell} isActiveBrokerage={this.props.isActiveBrokerage}>
                    {this.props.submission.type === 'oi' && (
                        <div>
                            <h3>Do you want to get a quote for Owners Contractor Protective?</h3>
                            <h4>Your application will be prefilled from your OI submission.</h4>
                        </div>
                    )}
                    {this.props.submission.type === 'ocp' && (
                        <div>
                            <h3>Do you want to get a quote for Owner&apos;s Interest?</h3>
                            <h4>Your application will be prefilled from your OCP submission.</h4>
                        </div>
                    )}
                </Upsell>

                <ContactUs user={this.props.user} />
            </div>
        );
    }
}

PendingStatus.propTypes = {
    handleUpsell: PropTypes.func,
    handleRequote: PropTypes.func,
    handleCoverageChange: PropTypes.func,
    user: PropTypes.object
};

export default connect(
    store => {
        return {
            app: store.app,
            user: store.user,
            ratings: store.ratings
        };
    },
    {
        fetchRatings: ratingsActions.fetch,
        fetchRatingsNoPricing: ratingsActions.fetchRatingsNoPricing,
        excessQuoteSelection,
        limitChange,
        adjustedCommissionChange,
        changePricingValue,
        loadArgopiReset: submissionActions.loadArgopiReset
    }
)(PendingStatus);
